import React from 'react';
import dynamic from 'next/dynamic';
import { withTranslation } from 'react-i18next';
import { Route, Switch, withRouter } from 'react-router-dom';
import wixService from '../services/wixService';

const Widget = dynamic(() =>
  import(/* webpackChunkName: "widget" */ '../components/widget'),
);
const Settings = dynamic(() =>
  import(/* webpackChunkName: "settings" */ '../components/settings'),
);

const Support = dynamic(() =>
  import(/* webpackChunkName: "support" */ '../components/support'),
);

// Style loader
import withEnhancedStyleLoader from '../withEnhancedStyleLoader';

class App extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      tab: 'tab-1',
    };
  }
  componentDidMount() {
    (async () => {
      if (wixService.isEditorMode()) {
        const privateApi = await this.props.editorSDK.editor.getAppAPI();
        const currentTab = await privateApi.getActiveTab();
        console.log({ currentTab });
        switch (
          currentTab // 'HOME' | 'DESIGN' | 'DISPLAY' | 'LAYOUT'
        ) {
          case 'DISPLAY':
            this.setState({ tab: 'tab-2' });
            break;
          case 'LAYOUT':
            this.setState({ tab: 'tab-3' });
            break;
          case 'DESIGN':
            this.setState({ tab: 'tab-5' });
            break;
          default:
            break;
        }
      }
    })();
  }

  render() {
    const { tab } = this.state;
    return (
      <Switch>
        <Route path="/settings">
          <Settings tab={tab} />
        </Route>
        <Route path="/support">
          <Support />
        </Route>
        <Route path="/mobile">
          <Widget />
        </Route>
        <Route path="/">
          <Widget />
        </Route>
      </Switch>
    );
  }
}

export default withRouter(withTranslation()(withEnhancedStyleLoader(App)));
